import React from 'react';
import { TabPanel, VStack } from '@televet/kibble-ui/build/chakra';
import { DetailsTab } from './DetailsTab';
import { AiRecapTab } from './AiRecapTab';
import { TabsLayout } from '@televet/kibble-ui/build/components/TabsLayout';

const tabList = [
  {
    label: 'Details',
    color: 'text.default',
    flex: 1,
  },
  {
    label: 'AI Recap',
    color: 'text.default',
    flex: 1,
  },
];

export const AppointmentModalBody = (): JSX.Element => {
  return (
    <VStack w="100%" spacing={1} mt={2}>
      <TabsLayout
        width="100%"
        tabList={tabList}
        tabPanels={[
          <TabPanel key={'appointment-details'}>
            <DetailsTab />
          </TabPanel>,
          <TabPanel key={'ai-recap-notes'}>
            <AiRecapTab />
          </TabPanel>,
        ]}
      />
    </VStack>
  );
};
